(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var scrollTimer;
    window.addEventListener(
      'scroll',
      function () {
        document.body.classList.add('wd-is-scrolling');
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          document.body.classList.remove('wd-is-scrolling');
        }, 200);
      },
      { passive: true }
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
